import { upperFirst, camelCase } from 'lodash';
export const pascalCase = (str) => upperFirst(camelCase(str));
const URL_TEMPLATE_REGEX = /.*\?(.*?)}?$/;
export const extractSearchParams = (str) => {
    const [, match] = URL_TEMPLATE_REGEX.exec(str) || [];
    return match || '';
};
//# sourceMappingURL=stringUtils.js.map